"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const span_1 = require("./span");
function useAnalyticsSpan(key, stream = "default") {
    react_1.useEffect(() => {
        const span = span_1.startSpan(key, stream);
        return () => {
            span_1.endSpan(span);
        };
    });
}
exports.default = useAnalyticsSpan;
